import { useThreeDotsOverlay } from "@/shared/components/generic/hooks/useThreeDotsOverlay.ts";

export function useWithThreeDotsOverlay() {
  const { showOverlay, hideOverlay } = useThreeDotsOverlay();

  return async <T>(
    action: () => Promise<T>,
    onError?: (error: unknown) => void,
  ): Promise<T | undefined> => {
    showOverlay();
    try {
      return await action();
    } catch (error) {
      if (onError) onError(error);
      return undefined;
    } finally {
      hideOverlay();
    }
  };
}
